<div class="mat-dialog-header">
  <div class="mat-dialog-title">Check In/Out Students</div>
  <fa-icon (click)="handleClose()" [icon]="['fas', 'close']"></fa-icon>
</div>
<div mat-dialog-content>
  <div class="first-row">
    <div class="custom-roster-name">
      Type the external student ID to check in/out.
    </div>
  </div>
  <div class="scan-form">
    <mat-form-field class="filter-item input scan-input" subscriptSizing="dynamic">
      <mat-label>Ext Student ID</mat-label>
      <input
        data-test-id="STUDENT_EXT_ID_FILTER_INPUT"
        matInput
        [formControl]="studentExtId"
        (keydown.enter)="checkInOutStudent()" />
    </mat-form-field>
    <button 
      mat-flat-button
      color="primary"
      class="scan-button check-button"
      (click)="checkInOutStudent()"
    >
      CHECK IN/OUT
    </button>
  </div>
</div>